// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import PlayerOverlay from 'components/pages/playback/PlayerOverlay';
import AreYouStillWatching from 'components/pages/AreYouStillWatching';

import PlayerFunnel from './PlayerFunnel';
import PlayerResource from './PlayerResource';
import Player from './Player';
import DRMProvider from './DRMProvider';

const PlaybackPage = ({
  videoId,
  rowId,
  isAutoplay,
  isDiscoveryRowVideo,
  onVideoCompleted,
  onError,
  onPrevVideo,
  onNextVideo,
}) => {
  const isCcEnabled = useSelector(state => state.closedCaptioning);

  return (
    <React.Fragment>
      <PlayerFunnel
        videoId={videoId}
        rowId={rowId}
        isDiscoveryRowVideo={isDiscoveryRowVideo}
        onError={onError}
        render={({
          videoToPlay,
          videoToDisplay,
          isGTAutoplay,
          row,
          authorizedProvider,
          loading: authLoading,
          onPlaybackError,
          onSetResource,
        }) => (
          <PlayerResource
            videoToPlay={videoToPlay}
            videoToDisplay={videoToDisplay}
            row={row}
            isAutoplay={isAutoplay || isGTAutoplay}
            authorizedProvider={authorizedProvider}
            onError={onError}
            render={({ resource, loading: resourceLoading }) => (
              <DRMProvider
                onError={onError}
                resource={resource}
                video={videoToPlay}
                render={({ resource: resourceWithDRM }) => {
                  return (
                    <Player
                      resource={resourceWithDRM}
                      onPlaylistComplete={onVideoCompleted}
                      onError={onPlaybackError}
                      isCcEnabled={isCcEnabled}
                      loading={authLoading || resourceLoading}
                      onResourceSet={onSetResource}
                      id={videoId}
                      inFocus
                    />
                  );
                }}
              />
            )}
          />
        )}
      />
      <PlayerOverlay onPrevVideo={onPrevVideo} onNextVideo={onNextVideo} />
      <AreYouStillWatching />
    </React.Fragment>
  );
};

PlaybackPage.propTypes = {
  videoId: PropTypes.string,
  rowId: PropTypes.string,
  isAutoplay: PropTypes.bool,
  isDiscoveryRowVideo: PropTypes.bool,
  onVideoCompleted: PropTypes.func,
  onError: PropTypes.func,
  onPrevVideo: PropTypes.func,
  onNextVideo: PropTypes.func,
};

PlaybackPage.defaultProps = {
  videoId: null,
  rowId: null,
  isAutoplay: false,
  isDiscoveryRowVideo: false,
  onVideoCompleted: () => null,
  onError: () => null,
  onPrevVideo: () => null,
  onNextVideo: () => null,
};
export default PlaybackPage;
